import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaChevronLeft } from 'react-icons/fa';

// Styled components for the breadcrumbs
const BreadcrumbsContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0;
  margin-bottom: 10px;
  direction: rtl;
  flex-wrap: wrap;
  font-family: ${({ theme }) => theme.fonts.primary};

  @media (max-width: 768px) {
    padding: 8px 0;
    font-size: 0.85rem;
  }
`;

const BreadcrumbItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  white-space: nowrap;

  &:last-child {
    color: ${({ theme }) => theme.colors.text.primary};
    font-weight: 600;
    white-space: normal;
  }

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }
`;

const BreadcrumbLink = styled(Link)`
  color: ${({ theme }) => theme.colors.text.secondary};
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
  }
`;

const Separator = styled(FaChevronLeft)`
  margin: 0 8px;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.colors.text.secondary};

  @media (max-width: 768px) {
    margin: 0 6px;
    font-size: 0.7rem;
  }
`;

// Interface for the breadcrumbs props
interface BreadcrumbItem {
  name: string;
  url: string;
  isCurrentPage?: boolean;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  // If no items, don't render the component
  if (items.length === 0) {
    return null;
  }

  return (
    <BreadcrumbsContainer>
      <BreadcrumbItem>
        <BreadcrumbLink to="/">דף הבית</BreadcrumbLink>
      </BreadcrumbItem>

      {items.map((item, index) => (
        <React.Fragment key={index}>
          <Separator />
          <BreadcrumbItem>
            {item.isCurrentPage ? (
              <span>{item.name}</span>
            ) : (
              <BreadcrumbLink to={item.url}>{item.name}</BreadcrumbLink>
            )}
          </BreadcrumbItem>
        </React.Fragment>
      ))}
    </BreadcrumbsContainer>
  );
};

export default Breadcrumbs;
